import { create } from "zustand";

type RepyamentScheduleType = {
  id: string;
  date: string | Date;
} | null;

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rs: RepyamentScheduleType;
  setRs: (rs: RepyamentScheduleType) => void;
}

export const useEditRepaymentSchedule = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  rs: null,
  setRs: (rs) =>
    set(() => ({
      rs,
    })),
}));
